import { useAppSelector } from "../../app";
import { useCallback } from "react";
import useAnnotationNormalization from "../../configMap/hooks/useAnnotationNormalization";
import { mapToEntityAnnotationDto } from "../../annotation/utils/annotationMappers";
import selectAnnotationReducer from "../../annotation/selectors/annotationReducerSelector";
import { getCategorizationIdsForEntityType } from "../../configMap/utils/entityCategorizationUtils";

const useEntityAnnotations = () => {
  const entityAnnotations = useAppSelector(selectAnnotationReducer);
  const configMap = useAppSelector((state) => state.configMapReducer.configMap);

  const { normalizeEntityAnnotationsInBulk } = useAnnotationNormalization();

  return useCallback(
    async (
      categorizationId: string,
      categorizationValue: string,
      index: number | undefined,
      hasGroupBlock: boolean,
    ) => {
      if (!configMap || !categorizationValue) {
        return;
      }

      const entityTypesWithCategorization: string[] = [];

      const uniqueEntityIds = [
        ...new Set(entityAnnotations.map((ea) => ea.entity.id)),
      ];

      for (const entityId of uniqueEntityIds) {
        const categorizationIds = getCategorizationIdsForEntityType(
          configMap,
          entityId,
        );
        if (categorizationIds.includes(categorizationId)) {
          entityTypesWithCategorization.push(entityId);
        }
      }

      if (!entityTypesWithCategorization.length) {
        return;
      }

      const filteredEntityAnnotations = entityAnnotations.filter(
        (ea) =>
          entityTypesWithCategorization.includes(ea.entity.id) &&
          (!hasGroupBlock || !index || ea.index === index),
      );

      const entityAnnotationsToNormalize = filteredEntityAnnotations
        .filter((ea) => ea.entity?.entityNormalizations?.length)
        .map((ea) => {
          return mapToEntityAnnotationDto(
            ea.id,
            ea.values.join(" "),
            ea.index ?? 1,
            ea.entity.entityNormalizations!,
            ea.entity.id,
            ea.multipleGroupBlocks,
            categorizationValue,
          );
        });

      console.log(
        "Normalize entity annotations: ",
        entityAnnotationsToNormalize,
      );
      normalizeEntityAnnotationsInBulk(entityAnnotationsToNormalize).catch(
        () => undefined,
      );
    },
    [entityAnnotations, normalizeEntityAnnotationsInBulk, configMap],
  );
};

export default useEntityAnnotations;
